import useVuelidate from '@vuelidate/core';
import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES, VERIFY_MAIL_TYPES } from '@/utils/constants';
import { ERROR_EMAIL_EXPIRED } from '@/utils/errorCodeList';
import {
  password,
  required,
  sameAsPassword,
} from '@/utils/validators';

export default {
  name: 'ResetPassword',
  setup() {
    return { resetPwdValidator$: useVuelidate({ $lazy: true }) };
  },
  data() {
    return {
      email: '',
      form: {
        confirmPassword: '',
        password: '',
      },
    };
  },
  computed: {
    ...mapState('user', {
      checkingToken: ({ checkTokenExpired }) => checkTokenExpired,
      settingPassword: ({ settingPassword }) => settingPassword,
    }),
    getPasswordMsg() {
      return this.hasErrorMsgs('password')
        ? this.getErrorMsgs('password') : '密碼長度必須8個字元以上，並且其中必須含英文字母及數字';
    },
  },
  async created() {
    const token = this.$route?.query?.confirmation_token;
    if (!token) {
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: '找不到驗證碼',
        msg: '請確認您的重設密碼網址無誤並重試。',
      });
      this.$router.replace('/login');
      return;
    }

    try {
      const { email = '' } = await this.checkTokenExpired(token);
      this.email = email;
    } catch (error) {
      const { message: msg, status } = error;
      this.$snackbar({
        type: SNACKBAR_TYPES.ERROR,
        title: 'Token驗證失敗',
        msg,
      });

      if (status === ERROR_EMAIL_EXPIRED) {
        this.$router.replace({ name: 'SendVerifyEmail', params: { type: VERIFY_MAIL_TYPES.RESET_PASSWORD } });
      } else {
        this.$router.replace('/login');
      }
    }
  },
  methods: {
    ...mapActions('user', {
      checkTokenExpired: 'CHECK_TOKEN_EXPIRED',
      setPassword: 'SET_PASSWORD',
    }),
    async confirm() {
      const valid = await this.resetPwdValidator$.$validate();
      if (!valid) return;

      try {
        await this.setPassword({
          confirmation_token: this.$route?.query?.confirmation_token,
          password: this.form?.confirmPassword,
        });
        this.$snackbar({ type: SNACKBAR_TYPES.SUCCESS, title: '完成重設密碼', msg: '密碼已重設完成，請直接登入。' });
        const params = this.email ? { email: encodeURIComponent(this.email) } : {};
        this.$router.replace({ name: 'Login', params });
      } catch (error) {
        const { message: msg } = error;
        this.$snackbar({ type: SNACKBAR_TYPES.ERROR, title: '重設密碼失敗', msg });
      }
    },
    getErrorMsgs(field) {
      return this.resetPwdValidator$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return !!this.resetPwdValidator$.form?.[field]?.$errors?.length;
    },
  },
  validations() {
    return {
      form: {
        password: { required: required('密碼'), password },
        confirmPassword: { required: required('確認密碼'), sameAsPassword: sameAsPassword(() => this.form.password) },
      },
    };
  },
};
